export default "__VITE_PUBLIC_ASSET__55bcc8af__"